import React from "react";
import { Link } from "react-router-dom";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { useTranslation } from "@/lib/i18n";
import { StockailySymbol } from "@/components/brand/StockailyBrand";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center flex flex-col items-center gap-4">
          {/* Stockaily brand v1.1 — transparent symbol, no wrapper tile. */}
          <div className="opacity-80">
            <StockailySymbol height={56} decorative />
          </div>
          <div className="font-display text-3xl">{t("not_found.title")}</div>
          <p className="text-muted-foreground -mt-2">{t("not_found.body")}</p>
          <Link to="/" className="underline mt-2 inline-block" data-testid="not-found-back-link">{t("not_found.back")}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
